module.exports = {
  message: {
    service_desc: 'Sử dụng công cụ để Swap COS giữa các định dạng Token khác nhau, bao gồm <strong>MainNet Native COS, BEP2, ERC-20 và BEP-20.</strong>',
    choose_token_type: 'Hướng Swap Token',
    fee_tips: '',
    token_type_erc20_to_bep2: 'ERC-20 => BEP2',
    token_type_erc20_to_native: 'ERC-20 => MainNet Native COS',
    token_type_bep2_to_erc20: 'BEP2 => ERC-20',
    token_type_bep2_to_native: 'BEP2 => MainNet Native COS',
    token_type_native_to_erc20: 'MainNet Native COS => ERC-20',
    token_type_native_to_bep2: 'MainNet Native COS => BEP2',
    token_type_bep20_to_native: 'BEP-20 => MainNet Native COS',
    token_type_native_to_bep20: 'MainNet Native COS => BEP-20',
    enter_address: 'Mục đích chuyển đổi tài khoản / địa chỉ của token',
    enter_exchange_memo: 'Memo (Địa chỉ đích dường như là một sàn giao dịch. Vui lòng nhập vào Memo để đảm bảo có thể nhận COS chính xác)',
    create_account_tips: 'Chưa có tài khoản? Tạo tài khoản ngay!',
    next_btn: 'Bước tiếp',
    start_over_btn: 'Bắt đầu lại',
    ready_to_swap: 'Sẵn sàng để Swap',
    transfer_prefix: 'Chuyển {token} của bạn sang',
    address: 'Tài khoản/Địa chỉ',
    memo: 'MEMO',
    auto_swap_desc: 'Vui lòng đảm bảo rằng TÀI KHOẢN / ĐỊA CHỈ của bạn được nhập vào là chính xác. công cụ Swap Token sẽ gửi số lượng token COS tương ứng đến ví chỉ định của bạn sau khi nhận được token của bạn. <strong>(Quá trình này mất khoảng 5 phút)<strong>.',
    auto_swap_desc_memo: 'Vui lòng đảm bảo rằng TÀI KHOẢN / ĐỊA CHỈ và MEMO của bạn được nhập vào là chính xác. công cụ Swap Token sẽ gửi số lượng token COS tương ứng đến ví chỉ định của bạn sau khi nhận được token của bạn. <strong>(Quá trình này mất khoảng 5 phút)<strong>.',
    main_net_address: 'Tài khoản Mainnet Contentos',
    bep2_address: 'Địa chỉ ví BEP2',
    erc20_address: 'Địa chỉ ví ERC-20',
    bep20_address: 'Địa chỉ ví BEP-20',
    main_net_token: 'MainNet Native COS',
    bep2_token: 'BEP2 COS',
    erc20_token: 'ERC-20 COS',
    bep20_token: 'BEP-20 COS',
    ok: 'Xác nhận',
    Cancel: 'Hủy',
    tips: 'Nhắc nhở',
    enter_address_tips: 'Vui lòng nhập đúng địa chỉ',
    enter_exChange_memo_tips: 'Vui lòng nhập đúng MEMO',
    swap_address_invalid: 'Địa chỉ không hợp lệ',
    swap_address_not_exit: 'Địa chỉ không tồn tại',
    swap_type_invalid: 'Hướng swap token không hợp lệ',
    swap_system_error: 'Lỗi hệ thống, vui lòng thử lại sau',
    swap_unknown_error: 'Lỗi không thể xác định, vui lòng thử lại sau',
    swap_memo_invalid: 'Invalid Memo',
    invalid_bnb_exChange_memo_tips: 'Binance exchange memo should be a number',
    paste_warning: 'Khi bạn dán địa chỉ, vui lòng kiểm tra địa chỉ đó khớp với địa chỉ bạn đã sao chép',
    fee_notice: 'Lưu ý: {fee} COS để làm phí gas sẽ được khấu trừ cho mỗi lần hoán đổi cho các giao dịch chuyển {token} giữa các tài khoản. Nếu số tiền ít hơn {fee} COS sẽ không được xử lý.',
    fee_subject_to_change: 'Phí dịch vụ có thể thay đổi mà không cần thông báo trước'
  }
}
